import {
  bookingItemAddedEvent,
  bookingItemRemovedEvent,
  cartViewedEvent,
  checkoutFinishedEvent,
  checkoutStartedEvent,
  itemDetailEvent,
  itemListEvent,
  loginEvent,
  logoutEvent,
  routeChangeEvent,
  RouteEvent,
  TrackingEvent as T
} from '@ibe/services';
import CustomTrackingEvent from './CustomTrackingEvent';
import { tracking } from './setup';
import {
  insuranceCheckoutAddedEvent,
  insurancePopupAddedEvent,
  itemExtraComponentListEvent,
  packageListEvent,
  upsellHotelAddedEvent,
  upsellPopupDisplayedEvent
} from './Events/Events';
import {
  addExtraEvent,
  additionalNightEvent,
  nameChangedEvent,
  rebookCompletelyEvent
} from './Events/mmbEvents';

function resetDataLayer() {
  if (window.dataLayer) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.dataLayer.push(function (this: any) {
      this.reset();
    });
  }
}

packageListEvent.subscribe(payload => {
  tracking.track(CustomTrackingEvent.PACKAGE_LIST_VIEW, payload, () => {
    resetDataLayer();
  });
});

itemExtraComponentListEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.PRODUCT_EXTRA_VIEW, payload, () => {
    resetDataLayer();
  })
);

checkoutStartedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.CART_CHECKOUT_START, payload, () => {
    resetDataLayer();
  })
);

checkoutFinishedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.CART_CHECKOUT_FINISH, payload, () => {
    resetDataLayer();
  })
);

itemListEvent.subscribe(payload =>
  tracking.track(T.PRODUCT_LIST_VIEW, payload, () => {
    resetDataLayer();
  })
);

itemDetailEvent.subscribe(payload =>
  tracking.track(T.PRODUCT_DETAIL_VIEW, payload, () => {
    resetDataLayer();
  })
);

insuranceCheckoutAddedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.INSURANCE_ADDED_CHECKOUT, payload, () => {
    resetDataLayer();
  })
);

insurancePopupAddedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.INSURANCE_ADDED_POPUP, payload, () => {
    resetDataLayer();
  })
);

cartViewedEvent.subscribe(payload =>
  tracking.track(T.CART_VIEW, payload, () => {
    resetDataLayer();
  })
);

bookingItemRemovedEvent.subscribe(payload =>
  tracking.track(T.CART_ITEM_REMOVED, payload, () => {
    resetDataLayer();
  })
);

bookingItemAddedEvent.subscribe(payload =>
  tracking.track(T.CART_ITEM_ADDED, payload, () => {
    resetDataLayer();
  })
);

routeChangeEvent.subscribe((event: RouteEvent) => {
  tracking.page();
});

loginEvent.subscribe(state => {
  tracking.track(T.LOGIN).then(() => {});
  if (state.user?.id) {
    tracking.identify(state.user.id, state).then(() => {});
  }
});

logoutEvent.subscribe(() => tracking.track(T.LOGOUT));

additionalNightEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.MMB_ADD_NIGHT, payload, () => {
    resetDataLayer();
  })
);

nameChangedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.MMB_NAME_CHANGE, payload, () => {
    resetDataLayer();
  })
);

rebookCompletelyEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.MMB_REBOOK_COMPLETELY, payload, () => {
    resetDataLayer();
  })
);

addExtraEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.MMB_EXTRAS_PURCHASE, payload, () => {
    resetDataLayer();
  })
);

upsellHotelAddedEvent.subscribe(payload =>
  tracking.track(CustomTrackingEvent.SUCCESSFUL_HOTEL_UPSELL, payload, () => {
    resetDataLayer();
  })
);

upsellPopupDisplayedEvent.subscribe(() => {
  tracking.track(CustomTrackingEvent.UPSELL_POPUP_DISPLAYED);
});
